import React from 'react';
import ConfigContext from './ConfigContext.js';
export default function ConfigProvider(_ref) {
  var config = _ref.config,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ConfigContext.Provider, {
    value: config
  }, children);
}